// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isIOS } from './utils/platform';
import { SplashScreen } from '@capacitor/splash-screen';
import { Analytics } from "@vercel/analytics/react";


/**
 * iOS/WebView-safe viewport height fix.
 * Use height: calc(var(--vh, 1vh) * 100) in CSS instead of 100vh
 * to avoid the Chrome/iOS URL bar shrinking bug.
 */
function setVhUnit() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setVhUnit();
window.addEventListener('resize', setVhUnit);
window.addEventListener('orientationchange', setVhUnit);

try {
  const isNative = !!(
    window?.Capacitor?.isNativePlatform &&
    window.Capacitor.isNativePlatform()
  );
  if (isNative) {
    document.documentElement.classList.add('cap-native');
  }
} catch {
  // no-op
}

// ✅ Add iOS class for Tailwind's ios: variant utilities
try {
  if (isIOS) {
    document.documentElement.classList.add('ios');
  }
} catch {
  // no-op
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);


// Keep native splash up until first frame is painted, then hide it.
// Safe to call whether launchAutoHide is true or false.
try {
  const isNative = !!(window?.Capacitor?.isNativePlatform && window.Capacitor.isNativePlatform());
  if (isNative) {
    requestAnimationFrame(() => {
      setTimeout(() => {
        SplashScreen.hide().catch(() => {});}, 50); 
    });
  }
} catch {
  // no-op
}


reportWebVitals();
